/**
 * currentEntityId actions
 */
import { SET_CURRENT_ENTITY_ID } from './constants';

export function setCurrentEntityId(entityId: number) {
    return {
        type: SET_CURRENT_ENTITY_ID,
        payload: {
            entityId
        }
    };
}
